import { render, staticRenderFns } from "./MaterialCheckbox.vue.js?vue&type=template&id=52da1357&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialCheckbox.vue?vue&type=template&id=52da1357&scoped=true"
import script from "./MaterialCheckbox.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MaterialCheckbox.vue.scss?vue&type=style&index=0&id=52da1357&prod&scoped=true&lang=scss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialCheckbox.vue?vue&type=style&index=0&id=52da1357&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da1357",
  null
  
)

export default component.exports